import { authClient, API } from '../index'

export const getSupportMessagesAdmin = (params) => {
  const search = new URLSearchParams()
  if (params?.limit) search.set('limit', String(params.limit))
  if (params?.readStatus) search.set('readStatus', String(params.readStatus))
  if (params?.replyStatus) search.set('replyStatus', String(params.replyStatus))
  if (params?.userId) search.set('userId', String(params.userId))
  if (params?.userQ) search.set('userQ', String(params.userQ))
  const q = search.toString()
  return authClient().get(`${API}/support-message/admin${q ? `?${q}` : ''}`)
}

export const getSupportMessageSendersAdmin = () => {
  return authClient().get(`${API}/support-message/admin/senders`)
}

export const getSupportMessageAdmin = (id) => {
  return authClient().get(`${API}/support-message/admin/${id}`)
}

export const markSupportMessageRead = (id) => {
  return authClient().patch(`${API}/support-message/${id}/read`)
}

export const replySupportMessage = (id, payload) => {
  return authClient().post(`${API}/support-message/${id}/reply`, payload)
}
